import styled from "styled-components";

export const LoginButton = styled.button`
  margin: 15px 0px;
  width: 300px;
  padding: 7px;
  cursor: pointer;
`;
